module.exports = __webpack_public_path__ + "static/media/gift.ac3abafe.png";